import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LinePanelAddIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M18 10h-4V3a1.0002 1.0002 0 0 0-1-1H8a1 1 0 0 0-1 1v5H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h15a1.0001 1.0001 0 0 0 1-1V11a1.0001 1.0001 0 0 0-1-1ZM7 20H4V10h3v10Zm5 0H9V4h3v16Zm5 0h-3v-8h3v8Zm4-16h-1V3a1.0002 1.0002 0 0 0-1.7071-.7071A1.0002 1.0002 0 0 0 18 3v1h-1a1 1 0 1 0 0 2h1v1a1.0002 1.0002 0 0 0 1.7071.7071A1.0002 1.0002 0 0 0 20 7V6h1a1 1 0 1 0 0-2Z"/>
  </SvgIcon>
}

export default LinePanelAddIcon
